var _filter, _g, _tspan, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2dd4bf",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5 L35 5 Q40 5 40 10 L40 35 Q40 40 35 40 L5 40 Z",
    fill: "none",
    stroke: "url(#primary-grad)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12 L12 33 Q25 33 25 22.5 Q25 12 12 12",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 15 L32 15 M27 15 L27 30 Q27 35 32 35",
    fill: "none",
    stroke: "url(#primary-grad)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 42,
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 32,
    fill: "#ffffff",
    style: {
      letterSpacing: "-1px"
    }
  }, "\n    DEV", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#primary-grad)"
  }, "TSTR"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 48,
    width: 130,
    height: 1,
    fill: "url(#primary-grad)",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 58,
    fontFamily: "Arial",
    fontSize: 8,
    fill: "#94a3b8",
    letterSpacing: 2
  }, "BUILD \u2022 VERIFY \u2022 OPTIMIZE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8a81c96f5e4661b23ca24b3e4665277.svg";
export { ForwardRef as ReactComponent };